<template>
  <div
    flat
    class="q-pr-sm q-pt-xs cursor-pointer q-pa-xs"
    @click="this.$router.push({ path: '/nepse-market-summary' })"
  >
    <div
      class="text-caption text-bold row justify-between"
      :class="this.$q.dark.mode === true ? '' : themeColor"
      style="font-size: 11px"
    >
      <div>
        As of :
        {{ new Date(this.$store.state.market.asOfLive).toDateString() }}

        {{ new Date(this.$store.state.market.asOfLive).toLocaleTimeString() }}
      </div>
      <div>
        <MarketLiveCloseStatus :smChipIncluded="false" />
      </div>
    </div>

    <div
      class="text-left text-body full-height text-weight-bold"
      :class="this.$q.dark.mode === true ? '' : 'text-grey-8 '"
      :style="`font-size: ${$q.screen.gt.xs ? '14px' : '14px'}`"
    >
      <!-- &nbsp; -->
      <div class="row">
        <span class="q-pr-xs text-h4" v-if="selectedIndexClosePriceData">
          {{ parseFloat(selectedIndexClosePriceData?.close).toFixed(2) }}
        </span>
        <q-icon
          size="xs"
          :color="
            selectedIndexClosePriceData?.percentage_change > 0 ? 'green' : 'red'
          "
          :name="
            selectedIndexClosePriceData?.percentage_change > 0
              ? 'north'
              : 'south'
          "
        ></q-icon>
        <span
          v-if="selectedIndexClosePriceData"
          :class="
            selectedIndexClosePriceData?.percentage_change > 0
              ? 'text-green text-caption text-bold '
              : 'text-red text-caption text-bold '
          "
        >
          <span style="font-size: 15px" class="text-caption row">
            <div>
              {{
                parseFloat(selectedIndexClosePriceData?.point_change).toFixed(2)
              }}
            </div>
            <q-separator vertical inset class="q-mx-sm"></q-separator>

            <div v-if="selectedIndexClosePriceData">
              {{
                parseFloat(
                  selectedIndexClosePriceData?.percentage_change
                ).toFixed(2)
              }}%
            </div>
          </span>
        </span>
      </div>
    </div>
    <q-separator></q-separator>

    <div
      class="text-caption text-weight-bold row justify-between"
      :class="this.$q.dark.mode === true ? '' : themeColor"
      :style="`font-size: ${$q.screen.gt.xs ? '13px' : '13px'}`"
    >
      <span class="text-bold q-pa-sm" v-if="selectedIndexClosePriceData">
        Turnover:

        {{ this.$utils.amountConversion(selectedIndexClosePriceData?.amount) }}
      </span>
      <!-- &nbsp; -->
      <q-separator vertical inset></q-separator>
      <!-- &nbsp; -->
      <span class="text-bold q-pa-sm" v-if="selectedIndexClosePriceData">
        Volume:
        {{ this.$utils.amountConversion(selectedIndexClosePriceData?.volume) }}
      </span>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import MarketLiveCloseStatus from "src/components/MarketLiveCloseStatus.vue";

import { LocalStorage, useQuasar } from "quasar";

import useData from "src/use/data";
import useMarket from "src/use/market";

export default {
  name: "StockIndexComponent",
  components: {
    MarketLiveCloseStatus,
  },
  props: {
    symbol: {
      type: String,
    },
    selectedIndexClosePriceData: {
      type: Object,
    },
    themeColor: {
      type: String,
    },
  },

  setup(props) {
    const $q = useQuasar();
    const store = useStore();
    const {
      intraIndexPerformance,
      stockPerformance,
      intraStockPerformance,
      indexPerformance,
    } = useData();
    const isStaff = ref(LocalStorage.getItem("whoAmI")?.is_staff || false);
    const { marketTime, getNepalTime } = useMarket();
    const routeName = computed(() => {
      return useRoute().name;
    });

    // const isMarketOn = ref(false);
    const isMarketOn = ref(LocalStorage.getItem("isMarketOn"));
    // isMarketOn.value = store.state.market.marketStatus;
    let intervalId = null;

    onUnmounted(() => {
      clearInterval(intervalId);
    });

    return {
      isMarketOn,
      routeName,
      isStaff,
    };
  },
};
</script>
